module.exports = __webpack_public_path__ + "static/media/notification.5b3e60c2.svg";